import { readUIState } from '@bridebook/web/lib/ai-planner/epics/ui-state';
import { restoreAIPlanner } from '@bridebook/web/lib/ai-planner/slice';
import { IEpic } from '@bridebook/web/lib/types';
import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';

/**
 * Reopens the panel on app start when it was left open. Server markup always
 * starts closed, so the restore lands just after first paint. It only ever
 * opens - another tab closing the panel must not pull this one shut.
 */
export const restoreAIPlannerPanelEpic: IEpic = (action$) =>
  action$.pipe(
    ofType('APP_STARTED'),
    filter(() => readUIState().isPanelOpen === true),
    map(() => restoreAIPlanner()),
  );
